<template>
	<td class="whitespace-nowrap px-3 py-4 text-sm text-gray-700">
		<slot />
	</td>
</template>
